<template>
  <div>
    <img class="bigBanner" :src="bgUrl" />
     <Product></Product>
     <Case></Case>
   <yxt-info class="wow slideInUp" id="yxtInfo"></yxt-info>
  </div>
</template>

<script>
import Product from "./component/product.vue";
import YxtInfo from '../home/components/yxtInfo.vue';
import Case from '../home/components/case.vue'
export default {
  name: "demo",
  components: {
    Product,
	YxtInfo,
    Case,
  },
  data() {
    return {
		bgUrl:require('@/assets/productPackage/banner.png')
    };
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.top {
  // margin: 26px 0;
  width: 606px;
  color: #333333;
  line-height: 38px;

  p {
    font-size: 16px;
  }
}

.titleLogo {
  width: 37px;
  height: 6px;
  margin-bottom: 12px;
}

.title-name {
  font-size: $global-font-size-32;
  color: $global-default-black-color;
  margin: 35px 0;
  text-align: center;
  // font-weight: 600;
}


.text1 {


  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  // font-weight: 600;
  color: #000000;
  line-height: 40px;
}

.text2 {

  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
</style>
